import ApplicationController from './controller/AppController';

export default ApplicationController;